import { Component, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { Client } from '../../../shared/client/client'
import { UserService } from '../../user/shared/user.service'

@Component({
  selector: 'app-commande-param-list',
  templateUrl: './commande-param-list.component.html',
  styleUrls: ['./commande-param-list.component.scss']
})
export class CommandeParamListComponent implements OnInit {
  private sub: Subscription
  loading = false
  columns = [
    { id: 'raison_sociale', libelle: 'Client' },
  ]
  displayedColumns: Array<string> = ['raison_sociale', 'actions']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  dataSource: MatTableDataSource<Client> = new MatTableDataSource<Client>()
  isSelected: boolean = true
  commandes
  lots
  filterValue = ''

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.dataSource.data = Array<any>()
    this.paginator._intl.itemsPerPageLabel = 'Clients par page '
    this.dataSource.paginator = this.paginator
    this.loading = true
    this.getClients()
  }

  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe()
    }
  }

  selectClient(client: Client) {
    this.router.navigate(['escli/linge-hebergement-param/', client.id])
  }

  getClients(filter: string = '') {
    if (this.sub) this.sub.unsubscribe()
    this.sub = this.userService.getClientsCommand(filter).subscribe(
      (clients) => {
        this.commandes = clients
        this.dataSource.data = this.commandes
        this.loading = false
      })
  }

  applyFilter(value: string) {
    this.sub.unsubscribe()
    this.loading = true
    if (this.isSelected) {
      if (!this.commandes) {
        this.dataSource.data = null
        if (this.sub) this.sub.unsubscribe()
        this.sub = this.userService.getClientsCommand('').subscribe(
          (clients) => {
            this.commandes = clients
            this.dataSource.data = this.commandes.filter(client => client.code_client.includes(value) || client.code_service.includes(value) || client.raison_sociale.toUpperCase().includes(value.toUpperCase()))
            this.loading = false
          })
      } else {
        this.dataSource.data = this.commandes.filter(client => client.code_client.includes(value) || client.code_service.includes(value) || client.raison_sociale.toUpperCase().includes(value.toUpperCase()))
        this.loading = false
      }
    } else {
      if (!this.lots) {
        this.dataSource.data = null
        if (this.sub) this.sub.unsubscribe()
        this.sub = this.userService.getClientsBesoin('').subscribe(
          (clients) => {
            this.lots = clients
            this.dataSource.data = this.lots.filter(client => client.code_client.includes(value) || client.code_service.includes(value) || client.raison_sociale.toUpperCase().includes(value.toUpperCase()))
            this.loading = false
          })
      } else {
        this.dataSource.data = this.lots.filter(client => client.code_client.includes(value) || client.code_service.includes(value) || client.raison_sociale.toUpperCase().includes(value.toUpperCase()))
        this.loading = false
      }
    }
  }

  reloadData(state: string) {
    this.loading = true
    this.filterValue = ''
    if (state === 'commandes') {
      this.isSelected = true
      if (!this.commandes) {
        this.dataSource.data = null
        if (this.sub) this.sub.unsubscribe()
        this.sub = this.userService.getClientsCommand('').subscribe(
          (clients) => {
            this.commandes = clients
            this.dataSource.data = this.commandes
            this.loading = false
          })
      } else {
        this.dataSource.data = this.commandes
        this.loading = false
      }
    } else if (state === 'lots') {
      this.isSelected = false
      if (!this.lots) {
        this.dataSource.data = null
        if (this.sub) this.sub.unsubscribe()
        this.sub = this.userService.getClientsBesoin('').subscribe(
          (clients) => {
            this.lots = clients
            this.dataSource.data = this.lots
            this.loading = false
          })
      } else {
        this.dataSource.data = this.lots
        this.loading = false
      }
    }
  }
}
